import { render, staticRenderFns } from "./TagsItem.vue?vue&type=template&id=602c747e&scoped=true"
import script from "./TagsItem.vue?vue&type=script&lang=js"
export * from "./TagsItem.vue?vue&type=script&lang=js"
import style0 from "./TagsItem.vue?vue&type=style&index=0&id=602c747e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602c747e",
  null
  
)

export default component.exports